import "./style.css";

export default class HomePageSpeakers {
  static selector = ".speaker-list";

  constructor(block) {
    this.block = block;
    this.showmoreButtons = this.block.querySelectorAll(".moreless-button");
    for (const button of this.showmoreButtons) {
      button.addEventListener("click", this.onReadMore);
    }
    
    window.addEventListener('load', this.onPeopleScroll);
  }
  onPeopleScroll = (e) => {
    e.preventDefault();

    const hash = window.location.hash,
          navHeight = jQuery('nav.header').outerHeight() + 30;

    if (hash !== '') {
      window.scrollTo({ top: jQuery(hash).offset().top - navHeight, behavior: "smooth" });
    }
  }  
  onReadMore = (e) => {
    e.preventDefault() ;
    const activeButton = e.currentTarget;
    const currentTabId = activeButton.dataset.id;
    const currentTab = this.block.querySelector("#"+currentTabId);
    currentTab.classList.toggle("active");
    if(activeButton.text == activeButton.dataset.more)
      activeButton.text = activeButton.dataset.less;
    else
      activeButton.text = activeButton.dataset.more;  
  };
}
